var map = {
	"./bbc-logo.png": 777,
	"./client-logo.png": 778,
	"./icons/backArrowCarousel.svg": 226,
	"./icons/iconFB.svg": 227,
	"./icons/iconTwitter.svg": 228,
	"./icons/nextArrow.svg": 229,
	"./icons/nextArrowCarousel.svg": 230,
	"./icons/nextArrowDark.svg": 231,
	"./icons/ovalArrow.svg": 232,
	"./icons/play.svg": 233,
	"./icons/playEpisode.svg": 234,
	"./icons/scroll_copy.svg": 235,
	"./icons/scroll_oval.svg": 236,
	"./layout/dotted_line.svg": 251,
	"./layout/dotted_oval.svg": 252,
	"./layout/oval.svg": 253,
	"./layout/oval_out.svg": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;